function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useEffect, useRef, useState } from 'react';
/**
 * This hook provides a way to attach a scroll event listener to a scroll area
 * inside a popover component. Popovers for picker components only exist when
 * the picker is open, and they get attached to the DOM outside of the child
 * tree, so we have to provide a function that can find the target DOM element
 * to attach the listener to.
 * @param findScrollArea Function to retreive the DOM element to attach a scroll
 * event listener to
 * @param onScroll Scroll event listener function to attach
 * @param getInitialScrollPosition Function to retrieve the initial scroll
 * position. If no function is given, or if the function returns `null`, no
 * initial scrolling will occur.
 */
export function usePopoverOnScrollRef(findScrollArea, onScroll, getInitialScrollPosition) {
  var ref = useRef(null);
  var isScrollOnOpenEnabledRef = useRef(false);
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    scrollAreaEl = _useState2[0],
    setScrollAreaEl = _useState2[1];
  var scrollToInitialPosition = useCallback(/*#__PURE__*/_asyncToGenerator(function* () {
    if (scrollAreaEl == null || getInitialScrollPosition == null) {
      return;
    }
    var position = yield getInitialScrollPosition();

    // If the position is null, don't scroll
    if (position == null) {
      return;
    }
    scrollAreaEl.scroll(0, position);
  }), [getInitialScrollPosition, scrollAreaEl]);
  useEffect(() => {
    scrollAreaEl === null || scrollAreaEl === void 0 || scrollAreaEl.addEventListener('scroll', onScroll);

    // Ticking tables can cause this effect to fire multiple times while the
    // popover is still open. This check ensures that we only scroll 1x.
    if (isScrollOnOpenEnabledRef.current) {
      scrollToInitialPosition();
      isScrollOnOpenEnabledRef.current = false;
    }
    return () => {
      scrollAreaEl === null || scrollAreaEl === void 0 || scrollAreaEl.removeEventListener('scroll', onScroll);
    };
  }, [onScroll, scrollAreaEl, scrollToInitialPosition]);
  var scrollTimeoutRef = useRef();

  // Popovers for picker components only exist when the popover opens, so we
  // have to wait to attach scroll listeners
  var onOpenChange = useCallback(isOpen => {
    window.clearTimeout(scrollTimeoutRef.current);
    if (isOpen) {
      isScrollOnOpenEnabledRef.current = true;

      // setTimeout is necessary for popover to be available
      scrollTimeoutRef.current = window.setTimeout(() => {
        setScrollAreaEl(findScrollArea(ref.current));
      }, 0);
    } else {
      setScrollAreaEl(null);
    }
  }, [findScrollArea]);
  return {
    ref,
    onOpenChange
  };
}
export default usePopoverOnScrollRef;
//# sourceMappingURL=usePopoverOnScrollRef.js.map